import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap/dist/css/bootstrap.css';
import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import OnboardingLandingPage from './MyComponents/OnboardingLandingPage';
import PageNotFound from './MyComponents/PageNotFound';
import WizardPersonalAccount from './MyComponents/Register/PersonalAccount/WizardPersonalAccount';
import EntityUnderReview from './MyComponents/Register/PersonalAccount/EntityUnderReview';
import WizardPersonalAccountKyc from './MyComponents/Kyc/PersonalAccount/WizardPersonalAccountKyc';
import WizardEntityAccount from './MyComponents/Register/EntityAccount/WizardEntityAccount';
import WizardLoginAccount from './MyComponents/Login/WizardLoginAccount';
import WizardResetPassword from './MyComponents/Login/WizardResetPassword';
// import PhonenoVerification from './MyComponents/Register/PersonalAccount/PhonenoVerification';
import VerifyEmail from './MyComponents/Login/VerifyEmail';
import OtpVerifyPhoneno from './MyComponents/Login/VerifyPhoneNo';
import PersonalAccountCreationSuccess from './MyComponents/Register/PersonalAccount/PersonalAccountCreationSuccess';
// import DocumentProcessing from './MyComponents/Register/PersonalAccount/DocumentProcessing';
import VerificationFail from './MyComponents/Register/PersonalAccount/VerificationFail';
import VerificationSuccess from './MyComponents/Register/PersonalAccount/VerificationSuccess';
import SecurityVerification from './MyComponents/Login/SecurityVerification';
import RecoveryAccount from './MyComponents/Login/RecoveryAccount';
import SecureIdentityVerification from './MyComponents/Login/SecureIdentityVerification';
import SecureIdentityVerificationNextPhase from './MyComponents/Login/SecureIdentityVerificationNextPhase';
import ConsentDecline from './MyComponents/Login/ConsentDecline';
import VerifyIdMethod from './MyComponents/Login/VerifyIdMethod';
import SecureIdentityVerificationMethods from './MyComponents/Login/SecureIdentityVerificationMethods';
import AllowCameraAccess from './MyComponents/Login/AllowCameraAccess';
import Dashboard from './MyComponents/Register/PersonalAccount/Dashboard';
import showResults from "./MyComponents/showResults";
import ErrorBoundary from 'MyComponents/ErrorBoundary';
import NotFoundPage from './MyComponents/PageNotFound';
import ServiceUnavailablePage from 'MyComponents/503';
import MaintenancePage from 'MyComponents/UnderMaintenance';
import { useEffect } from 'react';
import WizardEntityAccountKyc from 'MyComponents/Kyc/EntityAccount/WizardEntityAccountKyc';
import UserProfilePage from 'MyComponents/UserProfilePage';
import UserSwitchProfilePage from 'MyComponents/UserSwitchProfilePage';
import VerifyResetPassword from './MyComponents/Login/VerifyResetPassword';
import TermsOfService from './MyComponents/Legal/TermsOfService';
import PrivacyPolicy from './MyComponents/Legal/PrivacyPolicy';
import CookiesPolicy from './MyComponents/Legal/CookiesPolicy';
import GlobalAvailabilityPage from './MyComponents/Legal/GlobalAvailabilityPage';
import UserAgreement from './MyComponents/Legal/UserAgreement';
import AcceptableUsePolicy from './MyComponents/Legal/AcceptableUsePolicy';
import ESignConsent from './MyComponents/Legal/ESignConsent';
import RiskFactors from './MyComponents/Legal/RiskFactors';
import GeoGuard from './MyComponents/UI/GeoGuard';
import { GeoConfigProvider } from './context/GeoConfigContext';


function App() {
  useEffect(() => {
    let inMaintenanceMode: Boolean = false;
    const urlPath = window.location.pathname;
    const lastPart = urlPath.split('/').filter(Boolean).pop();
    if (inMaintenanceMode && lastPart != 'under-maintenance') window.location.href = '/under-maintenance';

  }, [window.location.href]);


  return (
    <GeoConfigProvider>
      <BrowserRouter>
        {/* GeoGuard must be inside BrowserRouter so it can read the current route */}
        <GeoGuard />
        <ErrorBoundary>
          <Routes>
            <Route path="/" element={<OnboardingLandingPage />} />
            <Route path="/404" element={<NotFoundPage />} />
            <Route path="/under-maintenance" element={<MaintenancePage />} />
            <Route path="/503" element={<ServiceUnavailablePage />} />
            <Route index element={<OnboardingLandingPage />} />
            <Route path="onboarding/:platform?" element={<WizardPersonalAccount />} />
            <Route path="onboarding/entity-pending" element={<EntityUnderReview />} />
            <Route path="/profile/:userid" element={<UserProfilePage />} />
            <Route path="/profile/list/:userid" element={<UserSwitchProfilePage />} />
            <Route path="onboardingEntityAccount" element={<WizardEntityAccount onSubmit={showResults} />} />
            <Route path="onboardingLoginAccount" element={<WizardLoginAccount onSubmit={showResults} />} />
            <Route path="kyc/personal/:userId/:kycToken" element={<WizardPersonalAccountKyc />} />
            <Route path="kyc/entity/:userId/:kycToken" element={<WizardEntityAccountKyc onSubmit={showResults} />} />
            <Route path="ResetPassword" element={<WizardResetPassword onSubmit={showResults} />} />
            <Route path="reset-password/verify" element={<VerifyResetPassword onSubmit={showResults} />} />
            <Route path="login_security_verify" element={<SecurityVerification />} />
            <Route path="recovery_account" element={<RecoveryAccount />} />
            <Route path="secure_identity_verify" element={<SecureIdentityVerification />} />
            <Route path="secure_identity_verify_next_phase" element={<SecureIdentityVerificationNextPhase />} />
            <Route path="consent_decline" element={<ConsentDecline />} />
            <Route path="verify_id" element={<VerifyIdMethod />} />
            <Route path="secure_identity_verify_methods" element={<SecureIdentityVerificationMethods />} />
            <Route path="allow_camera_access" element={<AllowCameraAccess />} />
            {/* <Route path="phone_verification" element={<PhonenoVerification />} />
            <Route path="document_processing" element={<DocumentProcessing />} /> */}
            <Route path="verify_failed" element={<VerificationFail />} />
            <Route path="verify_success" element={<VerificationSuccess />} />
            <Route path="personal_account_created" element={< PersonalAccountCreationSuccess />} />
            <Route path="otp_email_verification" element={<VerifyEmail />} />
            <Route path="otp_phoneno_verification" element={<OtpVerifyPhoneno />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="terms-of-service" element={<TermsOfService />} />
            <Route path="privacy-policy" element={<PrivacyPolicy />} />
            <Route path="cookies-policy" element={<CookiesPolicy />} />
            <Route path="global-availability" element={<GlobalAvailabilityPage />} />
            <Route path="user-agreement" element={<UserAgreement />} />
            <Route path="acceptable-use-policy" element={<AcceptableUsePolicy />} />
            <Route path="e-sign-consent" element={<ESignConsent />} />
            <Route path="risk-factors" element={<RiskFactors />} />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </ErrorBoundary>
      </BrowserRouter>
    </GeoConfigProvider>
  );
}

export default App;





